import { useState } from 'react'
import clsx from 'clsx'

import KinerjaDropdown from '.'

import type { KinerjaKsUtamaDetail } from 'types/kinerja-ks'
import type { KinerjaSelection } from 'types/kinerja'

type KinerjaDropdownGroupSingleProps = Omit<
  React.HTMLAttributes<HTMLDivElement>,
  'onChange' | 'className'
> & {
  kinerja: KinerjaSelection[]
  content: Array<KinerjaKsUtamaDetail>
  onChange?: (value: KinerjaSelection[]) => void
  addButtonLabel?: string
  baseNumber?: string | number
  className?: string
  showDeleteConfirmation?: boolean
  showPoint?: boolean
  offset?: number
  defaultUnselectedTargetQty?: string
}

const EMPTY_VALUE: KinerjaSelection = {
  id: 0,
  kuantitas: 0,
}

export default function KinerjaDropdownGroupSingle({
  kinerja,
  content,
  onChange = () => {},
  className = '',
  baseNumber,
  showDeleteConfirmation = false,
  showPoint = false,
  offset = 0,
  defaultUnselectedTargetQty = '',
  ...props
}: KinerjaDropdownGroupSingleProps) {
  const [values, setValues] = useState<KinerjaSelection[]>(
    kinerja.length > 0 ? kinerja : [EMPTY_VALUE]
  )

  const removeValue = (index: number) => {
    const newValues = [...values]
    newValues.splice(index, 1)
    return newValues
  }

  const onDelete = (index: number) => {
    const newValues = removeValue(index)
    onChange(newValues)

    if (newValues.length === 0) {
      setValues([EMPTY_VALUE])
    } else {
      setValues(newValues)
    }
  }

  const handleChange = (option: KinerjaSelection, index) => {
    const newValues = [...values]
    newValues[index] = option
    setValues(newValues)
    onChange(newValues)
  }

  return (
    <div className={clsx('flex flex-col gap-6', className)} {...props}>
      {values.map((value, index) => {
        const selectedOption = content.find(
          (content) => content.id === value.id
        )
        const remainingOptions = content.filter(
          (content) => !values.map((value) => value.id).includes(content.id)
        )

        return (
          <KinerjaDropdown
            single
            hideDetails
            dropdownLabel="Indikator Kompetensi"
            key={`KinerjaDropdown-${index}`}
            data-testid={`KinerjaDropdown-${index}`}
            kinerjaNumber={
              !!baseNumber
                ? `${baseNumber}.${index + 1}`
                : `${offset + index + 1}`
            }
            options={[
              ...(selectedOption ? [selectedOption] : []),
              ...remainingOptions,
            ]}
            value={value}
            onDelete={() => onDelete(index)}
            onChange={(option) => handleChange(option, index)}
            disableDeleteButton
            showPoint={showPoint}
            showDeleteConfirmation={showDeleteConfirmation}
            defaultUnselectedTargetQty={defaultUnselectedTargetQty}
          />
        )
      })}
    </div>
  )
}
